import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { BaseComponent } from "BaseComponent";
import { showError, showSuccess } from "ReduxErrorBar";
import { Row, Col, Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import _ from "lodash";
import { COMMON_FAIL_MESSAGE } from "Constants";
import LocaleStrings from "Languages";
import MasterLanguage from "LanguageList";
import DefaultEng from "DefaultEng";
import {
  openLanguageAddModal,
  addEventLanguage,
  fetchEventLanguages,
  checkLanguageExistEventwise,
} from "SettingActions";

class LanguageAdd extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { loading: false, validated: false };
  }

  close() {
    this.props.openLanguageAddModal(false);
  }

  onSubmitForm = (data) => {
    this.setState({ loading: true });
    let newdata = {};
    newdata.languagekey = data.languagekey.value;
    var checkValue = _.filter(MasterLanguage, function (opt) {
      return opt.code == newdata.languagekey;
    });
    if (checkValue.length > 0) {
      newdata.languagetext = checkValue[0].name;
    }
    newdata.languagejson = JSON.stringify(DefaultEng);
    newdata.eventid = this.props.session.eventid;
    this.props.checkLanguageExistEventwise(
      this.props.session,
      newdata.languagekey,
      (res) => {
        if (res.success && res.success == 1) {
          this.props.addEventLanguage(
            this.props.session,
            newdata,
            (response) => {
              if (response.success === 0) {
                this.props.showError(COMMON_FAIL_MESSAGE);
              } else {
                this.props.reset();
                this.props.fetchEventLanguages(
                  this.props.session,
                  (feedback) => {
                    if (feedback.data && feedback.data.length > 0) {
                      var checkValue = _.filter(feedback.data, function (opt) {
                        return opt.id == response.id;
                      });
                      if (checkValue.length > 0) {
                        this.props.reloadParent(checkValue);
                        this.props.showSuccess(
                          LocaleStrings.language_added_message
                        );
                        this.setState({ loading: false });
                        this.close();
                      }
                    }
                  }
                );
              }
            }
          );
        } else {
          this.setState({ loading: false });
          this.props.showError(LocaleStrings.language_already_exist);
        }
      }
    );
  };

  render() {
    var {
      handleSubmit,
      invalid,
      pristine,
      submitting,
      languageAddModalReducer,
    } = this.props;
    //console.log("languageAddModalReducer", languageAddModalReducer);

    let langArray = [];

    MasterLanguage.map((item, index) => {
      let obj = { label: `${item.name}`, value: item.code };

      langArray.push(obj);
    });
    //console.log("langArray", langArray);
    return (
      <div>
        <Modal
          className="modal-container"
          show={languageAddModalReducer === true ? true : false}
          onHide={this.close}
          animation={true}
          keyboard={false}
          backdrop="static"
          dialogClassName="modal-md"
        >
          <Modal.Header>
            <div className="import-modal-title">
              {LocaleStrings.language_setting_add_new_language}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.close()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleSubmit(this.onSubmitForm)}>
              <div className="row">
                <Field
                  name="languagekey"
                  label={LocaleStrings.language_setting_add_new_form_language}
                  placeholder={
                    LocaleStrings.language_setting_add_new_form_language_title
                  }
                  component={this.renderAutoComplete}
                  mandatory="true"
                  options={langArray}
                  labelKey="name"
                  valueKey="value"
                  isMulti={false}
                />
                {/* <Field
                  name="languagekey"
                  component={this.renderSelect}
                  opts={langArray}
                  label={LocaleStrings.language_setting_add_new_form_language}
                  placeholder={
                    LocaleStrings.language_setting_add_new_form_language_title
                  }
                /> */}
              </div>

              <div className="">
                <Button
                  className="btn-custom-blue"
                  loading={this.state.loading}
                  disabled={pristine || invalid || submitting}
                  type="submit"
                >
                  {LocaleStrings.add}
                </Button>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-custom-white"
              onClick={(e) => this.close()}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

function validate(values) {
  var errors = {};

  if (!values.languagekey) {
    errors.languagekey =
      LocaleStrings.language_setting_add_new_form_language_error;
  }

  return errors;
}

function mapStateToProps(state) {
  return {
    session: state.session,
    user: state.user,
    languageAddModalReducer: state.languageAddModalReducer,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  openLanguageAddModal,
  addEventLanguage,
  fetchEventLanguages,
  checkLanguageExistEventwise,
})(
  reduxForm({
    form: "LanguageAddForm",
    validate,
    /*asyncValidate,
        asyncBlurFields:['oldpwd'],*/
    enableReinitialize: true,
  })(LanguageAdd)
);
